export var VELT_SDK_VERSION = '6.0.8-beta.1';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '6.0.8-beta.1': 'sha384-Hj8ZYrvjmyYAqy5YhFQeVFHefd2EMKZ0FTc4heTIT4GbsMLH7r76A+CV4+P5zxrv',
};
